<template>
  <!-- Mobile Add to card page with credit card form and save button -->
  <div class="p-3 w-100">
    <template v-if="wallet">
      <h2>{{ $t('addPaymentMethod') }}</h2>
      <WCCreditCardForm
        :paymentMethod="wallet.creditPaymentMethod"
        @form-changed="tokenizeCallback = $event"
        @update:valid="continueEnabled = $event"
      />
      <WCInvisibleRecaptcha ref="recaptcha" />
      <button
        type="button"
        class="btn btn-primary btn-block mt-3 mx-auto save-btn"
        :disabled="!continueEnabled"
        @click="addWallet()"
      >
        {{ $t('saveCard') }}
      </button>
    </template>
  </div>
</template>

<script>
import WCCreditCardForm from '@/modules/checkout/components/WCCreditCardForm/WCCreditCardForm.vue';
import WCInvisibleRecaptcha from '@/modules/recaptcha/components/WCInvisibleRecaptcha/WCInvisibleRecaptcha.vue';
import SpinnerService from '@/services/spinner.service';
import WalletMixin from './mixins/WalletMixin';

export default {
  name: 'WCWalletAddCard',
  components: {
    WCCreditCardForm,
    WCInvisibleRecaptcha,
  },
  mixins: [WalletMixin], // Mixin to get addCard() method
  methods: {
    async addWallet() {
      try {
        SpinnerService.open();
        await this.addCard();
        this.$router.push({ name: 'Wallet' });
      } catch (e) {
        console.error(e);
      } finally {
        SpinnerService.close();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.save-btn {
  width: 50%;
  @include media-breakpoint-down(sm) {
    width: 100%;
  }
}
</style>
